<template>
  <div class="title">
    <span>{{ title }}</span>
    <figure class="title-info" v-tooltip="{ content: '어떤 순서로 입력하든 ART & ARTISTS 페이지에는 최신순으로 정렬됩니다.', placement: 'top', triggers: ['click'], autoHide: true}">
      <img src="@/assets/images/icon/ico_info.svg" alt="">
    </figure>
  </div>
  <div class="col field style-03">
    <div class="row" v-for="(item, index) in localData" :key="index" :class="{add : index != 0}">
      <CustomSelect v-model="item.year" :options="selectYearRange" placeholder="연도" fieldClass="field-one field-select-1 no-line" />
      <div class="field-one input-text-1 no-line">
        <input type="text" :placeholder="placeholder" maxlength="200" v-model="item.title">
      </div>
      <button v-if="index === localData.length - 1" type="button" class="add-list add" @click="addListItem()">
        <img src="@/assets/images/icon/ico_add_c.png" alt="">
      </button>
      <button type="button" class="add-list delete" @click="removeItem(index)">
        <img src="@/assets/images/icon/ico_minus_c.png" alt="">
      </button>
    </div>
  </div>
</template>

<script setup>
import { reactive, toRefs } from 'vue'
import { getSelectYearRange } from "@/common/common-function";
import CustomSelect from '@/components/ui/CustomSelect.vue';

const selectYearRange = getSelectYearRange();

const props = defineProps({
  title: String,
  placeholder: String,
  data: Array,
});
const { title, placeholder, data } = toRefs(props);

// props.data를 reactive 형태로 변환한 내부 데이터
const localData = reactive(
  (props.data && props.data.length > 0) // props.data가 유효한 경우
    ? props.data.map((item) => ({
      id: item.id,
      year: item.year,
      title: item.title, // 기존 문자열을 객체 속성으로 변환
    }))
    : [{ id: 0, year: '', title: '' }] // props.data가 없거나 빈 배열인 경우 기본값 추가
);

const addListItem = () => {
  const maxItems = 30;
  if (localData.length >= maxItems) {
    alert(`최대 ${maxItems}개까지 등록 가능합니다`);
    return;
  }
  localData.push({ id: 0, year: '', title: '' });
};

const removeItem = (index) => {
  localData.splice(index, 1);

  // 데이터가 비어 있으면 기본값 추가
  if (localData.length === 0) {
    addListItem();
  }
};

const getFilteredData = () => {
  return localData.filter(({ year, title }) => {
    return year && typeof title === 'string' && title.trim() !== '';
  });
};

const validateData = () => {
  let isAnyFieldFilled = false; // 최소 하나의 항목이 입력되었는지 확인

  for (const item of localData) {
    const { year, title } = item;
    if (year || title) {
      isAnyFieldFilled = true;
      if (!year || !title) {
        return {
          isValid: false,
          errorMessage:
            '입력 중인 수상 내역이 있습니다. 저장하시려면 모든 항목을 입력해주세요.\n사용하지 않을 정보라면 입력된 항목을 삭제해 주세요.',
        };
      }
    }
  }

  // Validation 성공
  return {
    isValid: true,
    errorMessage: null,
  };
};


defineExpose({
  getFilteredData,
  validateData
});
</script>

<style scoped></style>